import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Helmet from '../../../components/Helmet';
import CircularProgress from '../../../components/_loading/CircularProgress';
import Context from '../../../context';
import { useCompanyQuery } from '../../../../graphql/query/company/useCompanyQuery';
import NotFound from '../../../components/_error/NotFound';
import BusinessLayout from '../../../layout/Business';
import CompanyLogoUpload from '../../../components/_upload/CompanyLogoUpload';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  paper: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    width: '100%',
  },
}));

function BusinessLogo() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { company } = useContext(Context);
  const companyFragment = `
    _id
    media {
        images {
          logo {
            status
            filename
            filename_large
            
            filenameUrl
            filenameLargeUrl
          }
        }
    }
  `;
  const { data, loading } = useCompanyQuery(companyFragment, {
    variables: {
      filter: {
        _id: company._id as string,
      },
      limit: 1,
    },
  });

  const queryCompany = data ? data.companies.items[0] : null;

  if (loading) return <CircularProgress center color="primary" />;
  if (!queryCompany) return <NotFound />;

  return (
    <Paper square className={classes.paper}>
      <Helmet title={`${t('logo')} | ${t('business')}`} />
      <Grid container spacing={2}>
        <Grid container item xs={12} spacing={3}>
          <Grid item xs={12}>
            <CompanyLogoUpload
              companyId={queryCompany._id}
              logos={
                queryCompany.media &&
                queryCompany.media.images &&
                queryCompany.media.images.logo
                  ? queryCompany.media.images.logo
                  : []
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default () => <BusinessLayout main={<BusinessLogo />} />;
